// Which app page the search form opens in a modal, keyed by the route it lives
// at.
//
// The inversion matters: a popup body is a PAGE, and pages belong to the
// application, not to this component library. The app registers its own routes
// here at start-up, so adding a second or third popup later is an app component
// plus one registration line — no change in here, and no library release.
//
// Registering is also what makes "Opens as: Popup" safe to configure: an admin
// can only get a modal for a path the app itself has offered up, and any other
// path falls back to ordinary navigation (see runActionButton).

const SEARCH_POPUPS = new Map();

// A configured destination carries its query string ("/popup/description?id=1")
// and the registry is keyed by route, so both sides are compared on pathname.
export function popupPathOf(target) {
  return String(target ?? '').split('?')[0].split('#')[0];
}

export function registerSearchPopup(path, Component) {
  const key = popupPathOf(path);
  if (!key || typeof Component !== 'function') {
    throw new Error('registerSearchPopup(path, Component) requires a route path and a component');
  }
  SEARCH_POPUPS.set(key, Component);
  return Component;
}

export function getSearchPopup(target) {
  return SEARCH_POPUPS.get(popupPathOf(target));
}

export function unregisterSearchPopup(path) {
  return SEARCH_POPUPS.delete(popupPathOf(path));
}

// The query string a registered page would have read from the URL, handed to it
// as props instead — so one component serves as both the route and the modal
// body without caring which way it was reached.
export function popupParamsOf(target) {
  const query = String(target ?? '').split('?')[1];
  if (!query) return {};
  return Object.fromEntries(new URLSearchParams(query.split('#')[0]).entries());
}
